import { render, staticRenderFns } from "./CreateTag.modal.vue?vue&type=template&id=524dea54&scoped=true&"
import script from "./CreateTag.modal.vue?vue&type=script&lang=js&"
export * from "./CreateTag.modal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTag.modal.vue?vue&type=style&index=0&id=524dea54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524dea54",
  null
  
)

export default component.exports